import React from "react"
import { Link } from "react-router-dom"
import { ArrowRight } from "lucide-react"

export default function CTASection() {
  return (
    <section className="relative overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1483389127117-b6a2102724ae?w=1600&q=80&fit=crop"
          alt="Architecture"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-stone-950/80" />
      </div>

      <div className="relative z-10 py-28 lg:py-40">
        <div className="max-w-screen-2xl mx-auto px-6 lg:px-12 text-center">
          <span className="inline-flex items-center gap-2 font-['Space_Grotesk'] text-[10px] tracking-[0.3em] text-amber-400 uppercase mb-6">
            <span className="w-6 h-px bg-amber-400" />
            Let's Build Together
            <span className="w-6 h-px bg-amber-400" />
          </span>
          <h2 className="font-['Cormorant_Garamond'] text-5xl lg:text-8xl font-light text-stone-50 leading-tight mb-6 max-w-4xl mx-auto">
            Your vision.<br />
            <span className="italic text-amber-300">Our craft.</span>
          </h2>
          <p className="font-['Inter'] text-base text-stone-300 leading-relaxed mb-12 max-w-xl mx-auto">
            Every great project starts with a conversation. Tell us about your space, your aspirations, and your timeline.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="inline-flex items-center gap-3 bg-amber-400 text-stone-950 px-10 py-4 font-['Space_Grotesk'] text-xs tracking-[0.2em] font-medium hover:bg-amber-300 transition-colors group"
            >
              START A PROJECT
              <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
            </Link>
            <Link
              to="/works"
              className="inline-flex items-center gap-3 border border-stone-400/40 text-stone-200 px-10 py-4 font-['Space_Grotesk'] text-xs tracking-[0.2em] font-medium hover:border-stone-200 transition-colors"
            >
              VIEW OUR WORK
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
